import React from 'react'; 

import { deviceDetect } from 'react-device-detect';
// import eyeFill from '@iconify/icons-eva/eye-fill';
// import eyeOffFill from '@iconify/icons-eva/eye-off-fill'; 
// material
import { Stack, IconButton, InputAdornment,Typography, TextField } from '@mui/material';
// components
import ButtonContent from '../../components/formComponents/components/button';
import TextFieldContent from '../../components/formComponents/components/textField';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Button from '@mui/material/Button';
import { Navigate } from 'react-router-dom'; 
import './activate.css'
// import ErrorOutline from '@material-ui/icons/ErrorOutline';
import PasswordStrengthMeter from './passwordstrength'; 
import PasswordChecklist from "react-password-checklist";
// ----------------------------------------------------------------------
import Iconify from '../../components/Iconify';
import HTTPManager from '../../utils/httpRequestManager';

const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class ActivateForm extends React.Component {
  httpManager = new HTTPManager();
  constructor(props) {
    super(props);
    this.state = { 
      username: '',
      password: '', 
      error:'',
      isDisable: true,
      redirect:false,
      errorText:'',
      errorTextPassword:'',
      isTextEmpty: false,
      isPasswordEmpty: false,
      gotoRegister:false,
      userdetail:{},
      authcode:'',
      cpassword:'',     
      redirectDashboard: false, 
      isLoading: false,
      usererror: false,
      linkExpired: false,
      notmatcherror:false,
      iscDisable: false,
      iscPasswordEmpty: false,
      errorTextcPassword:'',
      showPassword:false,
      showcPassword:false,
      isValid: false
    };
    this.handlechange = this.handlechange.bind(this)
    this.handleShowPassword = this.handleShowPassword.bind(this)
    this.handleShowcPassword = this.handleShowcPassword.bind(this)
}

  componentDidMount(){ 
    var accessToken=window.localStorage.getItem('accessToken') || '' 
    if(accessToken === ''){ 
      this.httpManager.postRequest(`common/getToken`, deviceDetect(window.navigator.userAgent)).then(response=>{ 
        //console.log("REOPNSE")
        //console.log(response)
        window.localStorage.setItem('accessToken', response.token) 
        
      this.getUserDetail(); 
      });
    }
    else{
      
      this.getUserDetail(); 
    }
       
  }
  
  getUserDetail(){
    if(this.state.authcode !== ''){
      this.httpManager.postRequest(`/activate/getdetailbycode`,{code:this.state.authcode}).then(res=>{
        var result = res.data;
        //console.log("########")
        //console.log(result)
        if(result.userdetail !== undefined){  
          window.localStorage.removeItem('userdetail');
          window.localStorage.removeItem('token') 
          if(result.authdetail.isValid > 0 && result.authdetail.isVerified === 0){
              this.setState({userdetail: result.userdetail, authdetail: result.authdetail}, function(){
                this.setState({isLoading:false, username: this.state.userdetail.userName})
              })
            }
            else{ 
              this.setState({linkExpired:true}, function(){
                this.setState({isLoading:false})
              })
            }
        }
        else{
          this.setState({usererror:true, isLoading:false})
        }
      }).catch(e=>{
        //console.log(e)
        this.setState({usererror:true, isLoading:false})
      })
    }
    else{
      setTimeout(() => {
          this.getUserDetail();
      }, 1000);
    }
  }

  renderRedirect = () => {
    if (this.state.redirect) {
      return  <Navigate to='/dashboard/merchant/review' />
    }
    else if (this.state.redirectDashboard) {
      return  <Navigate to='/dashboard' />
    }
    else {
      return <div></div>
    }
  }

  onBlurField(){
    if(!this.state.username){
          this.setState({ errorText: 'Field Required', isTextEmpty: true, isDisable: true })
    }
    else{
      this.setState({ 
          isDisable: false, 
          errorText: '', 
          isTextEmpty: false,
      })
    }
  }

  onBlurPassField(){
      if(!this.state.password){
          this.setState({ errorTextPassword: 'Field Required', isPasswordEmpty: true, isDisable: true })
      }
      else{
        this.setState({ 
            isDisable: false, 
            errorTextPassword:'', 
            isPasswordEmpty: false,
        })
      }
  }

  onBlurCPassField(){
      if(!this.state.cpassword){
          this.setState({ errorTextcPassword: 'Field Required', iscPasswordEmpty: true, iscDisable: true })
      }
      else{
        //console.log(this.state.password,"===",this.state.cpassword)
        if(this.state.password === this.state.cpassword){
          this.setState({ 
              iscDisable: false, 
              errorTextcPassword:'', 
              iscPasswordEmpty: false,
          })
        }
        else{
          this.setState({ errorTextcPassword: 'Passwords mismatch.', iscPasswordEmpty: true, iscDisable: true })
        }
      }
  }

  submit(){
    if(this.state.password === this.state.cpassword){
      var userdetail = {}  
      userdetail["userName"] = this.state.username;
      userdetail["password"] = this.state.password;
      userdetail["id"] = this.state.userdetail.id; 
      userdetail["code"] = this.state.authdetail.verificationCode;
      userdetail["userType"] = this.state.authdetail.userType;
//console.log(userdetail);
      this.setState({error:''});

      this.httpManager.postRequest(`/activate/activateUser`, userdetail).then(res=>{
        window.localStorage.setItem("userdetail", JSON.stringify(res.data));
        toast.success('Redirecting to dashboard...', {
          position: "top-center",
          autoClose: 5000,
          closeButton:false,
          hideProgressBar: true,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
          });

          setTimeout(() => {
            window.location = "http://"+window.location.host;
          }, 1000);
      })

      // axios.post(process.env.REACT_APP_APIURL+"/users/saveUser", userdetail).then(res=>{
      //   var data = res.data["data"];
      //   if(data.affectedRows > 0){ 
      //       axios.post(process.env.REACT_APP_APIURL+"/users/verifyuser", {UserId:this.state.userdetail.id, isVerified:1, authid:this.state.userdetail.authid}).then(res=>{
      //         var result = res.data;
      //         if(result.status===200){
      //           window.localStorage.setItem("userdetail", JSON.stringify(this.state.userdetail))
      //           toast.success('Redirecting to dashboard...', {
      //             position: "top-center",
      //             autoClose: 5000,
      //             closeButton:false,
      //             hideProgressBar: true,
      //             closeOnClick: false,
      //             pauseOnHover: false,
      //             draggable: false,
      //             progress: undefined,
      //             });
      //             if(this.state.userdetail.userType !== 'CastleNova'){
      //               // this.setState({redirectDashboard:true})
      //               window.location = "http://"+window.location.host;
      //             }
      //             else{ 
      //               window.location = "http://"+window.location.host;
      //               // this.setState({redirect:true});
      //             }
      //         }
      //         else{
      //           toast.error('Error occured. Please try again later.', {
      //             position: "bottom-center",
      //             autoClose: false,
      //             closeButton:true,
      //             hideProgressBar: true,
      //             closeOnClick: false,
      //             pauseOnHover: false,
      //             draggable: false,
      //             progress: undefined,
      //             });
      //             this.setState({error:"Details are not updated."})
      //         }
      //     })
      //   }
      //   else{
      //     toast.error('Error occured. Please try again later.', {
      //       position: "bottom-center",
      //       autoClose: false,
      //       closeButton:true,
      //       hideProgressBar: true,
      //       closeOnClick: false,
      //       pauseOnHover: false,
      //       draggable: false,
      //       progress: undefined,
      //       });
      //       this.setState({error:"Details are not updated."})
      //   }
      // }).catch(err=>{      
      //   this.setState({error:"Invalid username or password."})
      // })
    }
    else{
      this.setState({notmatcherror:true})
    }
  }

  handlechange(e){
    let statevbl = this.state
    statevbl[e.target.name] = e.target.value;
    this.setState(statevbl);
  }

  handleShowPassword = () => {
    this.setState((prevState) => ({
      showPassword: !prevState.showPassword
    }));
  };


  handleShowcPassword = () => {
    this.setState((prevState) => ({
      showcPassword: !prevState.showcPassword
    }));
  };


  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.authcode !== prevState.authcode) {
      return { authcode: nextProps.authcode };
    }
    return null;
  }
  

  render() {
    return (<>

      {this.renderRedirect()} 
      <form autoComplete="off" noValidate>

      {this.state.isLoading &&  <div align="center"><img src="/images/spinner.gif" alt="Loading..." width="50"/></div>}
      {!this.state.isLoading && !this.state.usererror && !this.state.linkExpired && <>
     {this.state.userdetail !== undefined && <><Stack sx={{ mb: 5 }}>
              <Typography variant="h4" gutterBottom>
                Account Activation
              </Typography> 
            </Stack> 

        <Stack spacing={3}>
          
        <TextField variant="outlined" 
            fullWidth
            type= 'text' 
            key="username"
            label='Username'
            placeholder="Username"
            name="username"
            value={this.state.userdetail.userName || ''} 
            disabled
          />
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} style={{display:'flex', flexGrow:'1', flexBasis:"0"}}>

              <Stack direction={{ xs: 'column', sm: 'column' }} spacing={2}>
            <TextFieldContent
                fullWidth
                type={this.state.showPassword ? 'text' : 'password'}
                label="Password"
                name="password"
                value={this.state.password}
                onChange={(e)=>{this.handlechange(e)}}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={this.handleShowPassword} edge="end">
                        {this.state.showPassword && getIcon('mdi:eye-outline')}
                        {!this.state.showPassword && getIcon('mdi:eye-off-outline')}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <PasswordStrengthMeter password={this.state.password} />
              </Stack>
              <Stack direction={{ xs: 'column', sm: 'column' }} spacing={2}>
                <TextFieldContent
                  fullWidth
                  type={this.state.showcPassword ? 'text' : 'password'}
                  label="Confirm Password"
                  name="cpassword"
                  value={this.state.cpassword}
                  onChange={(e)=>{this.handlechange(e)}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton onClick={this.handleShowcPassword} edge="end">
                          {this.state.showcPassword && getIcon('mdi:eye-outline')}
                          {!this.state.showcPassword && getIcon('mdi:eye-off-outline')}
                        </IconButton>
                      </InputAdornment>
                    )
                  }}
                />
              </Stack>
          </Stack>
              <Stack direction={{xs:'column', sm:'column'}} spacing={2}> 
                  <PasswordChecklist
                    rules={["minLength","specialChar","number","capital","match"]}
                    minLength={8}
                    value={this.state.password}
                    valueAgain={this.state.cpassword}
                    onChange={(isValid) => {
                      this.setState({isValid: isValid});
                    }}
                  />
              </Stack>
          <ButtonContent 
          className="submitbtn"
            component={Button}
            disabled={!this.state.isValid}
            onClick={()=>{this.submit()}}
            size="large"
            type="submit"
            variant="contained"
            label="Submit"
          />
        </Stack> 
        </>}
        </>
                          }
{!this.state.isLoading && this.state.usererror && <>
                        <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                            {/* <ErrorOutline className="erroricon"/> */}
                            <Typography variant="h5">Sorry, this activation link is not valid.</Typography>
                            </div>
                          </>}
                        {!this.state.isLoading && this.state.linkExpired && <>
                        <div style={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                            {/* <ErrorOutline className="erroricon"/> */}
                            <Typography variant="h5">Sorry, this activation link is expired.</Typography>
                            </div>
                          </>}
      </form>
      </>
    );
  }
}
